import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { Icon } from "@iconify/react";
import { useRef } from "react";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a128,
  a129,
  a130,
  a131,
  a132,
  a133,
  a137,
  a138,
  a139,
  a140,
  a141,
  a142,
  a143,
  a144,
  a145,
  a146,
  a147,
  a148,
  a18,
  a35,
  a7,
  a726,
  a727,
  a728,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import style from "./AddStoneNew.module.css";

import Customertable from "Components/support/customervendor/customer";
import { Box } from "@mui/material";
import toast from "react-hot-toast";
import { fetchAllStoneAttribute } from "services/stone";
import { useQuery } from "@tanstack/react-query";
import { addStoneCategory } from "utils/helpers";
import exportToExcel from "Components/CommonComponents/ExcelDownload";

export default function AddStoneNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    StoneName: "",
    StoneWeight: "0",
    StonePieces: "1",
    StoneRate: "0",
    StoneAmount: "0",
    StoneColour: "",
    StoneShape: "",
    StoneSize: "",
    // StoneLessPercent: "",
    Description: "",
    StoneStatusType:"deduct",
    StoneCategory: "12",
    StoneLessPercent: "",
    StoneCertificate: "",
    StoneRatePerPiece: "",
    StoneSettingType: "",
    StoneWeightType: "",
 
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;

  const {
    data: allStoneAttribute,
    isLoading: allStoneAttributeLoading,
    isError: allStoneAttributeIsError,
  } = useQuery({
    queryKey: ["stone/fetchStoneAttribute", clientCode],
    queryFn: fetchAllStoneAttribute,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });


  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a726, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Department First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Role First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Categories First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategoriesList();
  }, []);

  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllProductsList();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    if (name === "StoneWeight" || name === "StoneRate") {
      newCategory.StoneAmount =
        (name === "StoneRate" ? value : newCategory.StoneRate) *
        (name == "StoneWeight" ? value : newCategory.StoneWeight);
    }
    setNewCategory({ ...newCategory, [name]: value });
  };


  const addNewCategory = async (e) => {
    e.preventDefault();

    const nameExists = allCategories.some(
      (category) =>
        category.StoneName.toLowerCase() === newCategory.StoneName.toLowerCase()
    );

    console.log(newCategory)
    if (nameExists && !newCategory?.OldEntry) {
      // setMessageType("error");
      // setMessageToShow("Stone name already exists.");
      toast.error("Stone name already exists.",{
        position:'top-center',
        duration:2000
      })
      // setShowError(true);
      // setLoading(false);
      return;
    }

    setLoading(true);
    const formData = {
      StoneName: newCategory.StoneName,
      StoneWeight: newCategory.StoneWeight,
      StonePieces: newCategory.StonePieces,
      StoneRate: newCategory.StoneRate,
      StoneColour: newCategory.StoneColour,
      StoneWeightType: newCategory.StoneWeightType,
      StoneShape: newCategory.StoneShape,
      StoneSize: newCategory.StoneSize,
      StoneCertificate: newCategory.StoneCertificate,
      StoneAmount: String(newCategory.StoneAmount),
      Description: newCategory.Description,
      StoneStatusType: newCategory.StoneStatusType,
      StoneCategory: newCategory.StoneCategory,
      StoneRatePerPiece: `${+(newCategory.StoneRatePerPiece || 0)}`,
      StoneSettingType: newCategory.StoneSettingType,
      StoneLessPercent: newCategory.StoneLessPercent
        ? newCategory.StoneLessPercent
        : "100",
      ClientCode: clientCode,
      EmployeeCode: newCategory.EmployeeCode ? newCategory.EmployeeCode : 0,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a728 : a727,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        StoneName: "",
        StoneWeight: "0",
        StonePieces: "1",
        StoneWeightType: "",
        StoneRate: "0",
        StoneAmount: "0",
        StoneColour: "",
        StoneShape: "",
        StoneSize: "",
        StoneLessPercent: "",
        StoneCertificate: "",
        Description: "",
        StoneCategory:"12",
        StoneRatePerPiece: "",
        StoneSettingType: "",
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message,{
          duration: 3000,
          position: "top-center",
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Stone Added Successfully", {
          duration: 3000,
          position: "top-center",
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "StoneName", label: "Stone Name", type: "read", priority: 1 },

    { key: "StoneWeight", label: "Stone Weight", type: "read", priority: 3 },
    { key: "StonePieces", label: "Stone Pieces", type: "read", priority: 4 },
    { key: "StoneRate", label: "Stone Rate", type: "read", priority: 5 },
    { key: "StoneAmount", label: "Stone Amount", type: "read", priority: 6 },

    {
      key: "Description",
      label: "Description",
      type: "read",
      priority: 7,
    },
  ];

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputResf16 = useRef(null);

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      }
      // else {
      //   if (submitButtonRef.current) {
      //     submitButtonRef.current.click(); // Safely trigger click
      //   } else {
      //     console.error("Submit button ref is not available");
      //   }
      // }
    }
  };

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleList = () => {
    // Custom logic for the List button
    setActive("List");
  };
  const handlenew = () => {
    setActive("AddNew");
  };


  const DownloadExcel = (data)=>{
      const headers = {
        'S.No': null, // Auto-generated
        'Stone Name': 'StoneName',
        'Stone Weight': 'StoneWeight',
        'Stone Pieces': 'StonePieces',
        'Stone Rate': 'StoneRate',
        'Stone Amount': 'StoneAmount',
        'Description': 'Description',
       
      };
      exportToExcel(data, headers, 'StoneData.xlsx');
    }
  
  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Stone"}
          companyName={"Loyalstring"}
          module={"Product Masters"}
          page={"Stone"}
        />
      </div>

      <div style={{ padding: "16px" }}>
        {active == "List" ? (
          <>
            <div className={style["white-space"]}>
              <div className={style["icon-div"]}>
                <div className={style["search-container"]}>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    className={style["serach-input"]}
                  />
                  <button
                    style={{ margin: 0 }}
                    className={style["search-btn"]}
                    onClick={handleSearchSubmit}
                  >
                    <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                  </button>
                </div>

                <Icon
                onClick={()=>DownloadExcel(allCategories)}
                  style={{
                    fontSize: "28px ",
                    color: "#0077d4",
                    cursor: "pointer",
                  }}
                  icon="bx:export"
                />

                <button
                  // style={{ width: "30%" }}
                  className={style["custom-btn"]}
                >
                  <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
                  Print
                </button>
                <button
                  onClick={handlenew}
                  style={{ margin: 0 }}
                  className={style["custom-btn"]}
                >
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
              </div>
            </div>

            <Customertable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <form onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,2fr)",
                      columnGap: "30px",
                      margin: "0px 0px",
                      padding: "var(--Space-0, 0px) 24px",
                    }}
                    // className="adminCategoryAddCategoryInnerBox"
                  >
                    <Box sx={{ width: "95%", margin: "0 auto" }}>
                      <div
                        style={{
                          gridTemplateColumns: "repeat(4,1fr)",
                          columnGap: "40px",
                          margin: "15px 0px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>Stone Category <sup>*</sup></label>
                        {/* <input
                          name="StoneCategory"
                          value={newCategory.StoneCategory}
                          onChange={handleNewCategoryChange}
                          type="text"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef1)}
                        /> */}
                        <select
                          name="StoneCategory"
                          value={newCategory.StoneCategory}
                          onChange={handleNewCategoryChange}
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef1)}
                        >
                          <option value="">Select Category</option>
                          {
                            addStoneCategory.map((item) => (
                              <option value={item?.Id}>
                                {item?.StoneValue}
                              </option>
                            ))}
                        </select>
                        <label>Unit</label>
                        <select
                          name="StoneWeightType"
                          value={newCategory.StoneWeightType}
                          onChange={handleNewCategoryChange}
                          required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                        >
                          <option value="">Select Unit</option>
                          <option value="Gram">Gram</option>
                          <option value="Karat">Carat</option>
                        </select>
                        <label>
                          Stone Name<sup>*</sup>
                        </label>
                        <input
                          name="StoneName"
                          value={newCategory.StoneName}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                        />
                        {/* <label>
                                        Stone Less Percent<sup>*</sup>
                                    </label>
                                    <input
                                        name="StoneLessPercent"
                                        value={newCategory.StoneLessPercent}
                                        onChange={handleNewCategoryChange}
                                        type="text"
                                    /> */}

                       

                        <label>
                          Stone Pieces<sup>*</sup>
                        </label>
                        <input
                          name="StonePieces"
                          value={newCategory.StonePieces}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef4}
                          disabled={true}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                        />
 <label>
                          Stone Weight<sup></sup>
                        </label>
                        <input
                          name="StoneWeight"
                          value={newCategory.StoneWeight}
                          onChange={handleNewCategoryChange}
                          type="text"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        />
                       

                        <label>
                          {`Stone Rate/${
                            newCategory?.StoneWeightType == "Karat"
                              ? "Carat"
                              : newCategory?.StoneWeightType == "Gram"
                              ? "Gram"
                              : "Weight"
                          }`}
                        </label>
                        <input
                          name="StoneRate"
                          value={newCategory.StoneRate}
                          disabled={+(newCategory?.StoneRatePerPiece || 0)}
                          onChange={(e) => {
                            // setNewCategory({...newCategory,StoneRatePerPiece:""})
                            handleNewCategoryChange(e);
                          }}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        />

                        {/* <label>Stone Rate</label>
                                    <input
                                        name="StoneRate"
                                        value={newCategory.StoneRate}
                                        onChange={handleNewCategoryChange}
                                        type="text"
                                    // required="required"
                                    />
                                    <label>Stone Rate/Karate</label>
                                    <input
                                        name="StoneRate"
                                        value={newCategory.StoneRate}
                                        onChange={handleNewCategoryChange}
                                        type="text"
                                    // required="required"
                                    /> */}

                        <label>Stone Rate / Piece</label>
                        <input
                          name="StoneRatePerPiece"
                          disabled={+(newCategory?.StoneRate || 0)}
                          value={newCategory.StoneRatePerPiece}
                          onChange={handleNewCategoryChange}
                          type="text"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        />
                        <label>Stone Amount</label>
                        <input
                          name="StoneAmount"
                          value={newCategory.StoneAmount}
                          onChange={handleNewCategoryChange}
                          type="text"
                          readOnly={true}
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        />

                        <label>Stone Shape</label>
                        <select
                          name="StoneShape"
                          value={newCategory.StoneShape}
                          onChange={handleNewCategoryChange}
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef9}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        >
                          <option value="">Select Shape</option>
                          {allStoneAttribute?.length ? allStoneAttribute?.filter(
                              (item) => item?.StoneAttribute == "StoneShape"
                            )
                            ?.map((item) => (
                              <option value={item?.Id}>
                                {item?.StoneValue}
                              </option>
                            )) :""}
                        </select>

                        <label>Stone Color</label>
                        <select
                          name="StoneColour"
                          value={newCategory?.StoneColour}
                          onChange={handleNewCategoryChange}
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef10}
                          onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        >
                          <option value="">Select Colour</option>
                          {allStoneAttribute?.length ? allStoneAttribute?.filter(
                              (item) => item?.StoneAttribute == "StoneColor"
                            )
                            ?.map((item) => (
                              <option value={item?.Id}>
                                {item?.StoneValue}
                              </option>
                            )) :""}
                        </select>

                        <label>Stone Size</label>
                        <select
                          name="StoneSize"
                          value={newCategory?.StoneSize}
                          onChange={handleNewCategoryChange}
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                        >
                          <option value="">Select Size</option>
                          {allStoneAttribute?.length ? allStoneAttribute
                            ?.filter(
                              (item) => item?.StoneAttribute == "StoneSize"
                            )
                            ?.map((item) => (
                              <option value={item?.Id}>
                                {item?.StoneValue}
                              </option>
                            )) :""}
                        </select>

                        {/* <label>Stone Less Percentage</label>
                        <input
                          name="StoneLessPercent"
                          value={newCategory.StoneLessPercent}
                          onChange={handleNewCategoryChange}
                          type="number"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        /> */}
                        {/* <label>Stone Certificate</label>
                        <input
                          name="StoneCertificate"
                          value={newCategory.StoneCertificate}
                          onChange={handleNewCategoryChange}
                          type="text"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        /> */}

                        <label>Stone Setting Type</label>
                        <select
                          name="StoneSettingType"
                          value={newCategory.StoneSettingType}
                          onChange={handleNewCategoryChange}
                          type="text"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        >
                          <option value="">Select Setting Type</option>
                          <option value="StoneShape">Stone Shape</option>
                          <option value="StoneClarity">Stone Clarity</option>
                          <option value="StoneColor">Stone Color</option>
                          <option value="StoneSize">Stone Size</option>
                          <option value="StoneType">Stone Type</option>
                        </select>
                        <label>Description</label>
                        <input
                          name="Description"
                          value={newCategory.Description}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef13}
                          onKeyDown={(e) => handleKeyPress(e, null)}
                        />

                         <label>Stone Status</label>
                        <select
                          name="StoneStatusType"
                          value={newCategory.StoneStatusType}
                          onChange={handleNewCategoryChange}
                          type="text"
                          // required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef14}
                          onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                        >
                          <option value="">Select Stone Status</option>
                          <option value="deduct">Deduct</option>
                          <option value="dontDeduct">Don't Deduct</option>
                         
                        </select>
                        {/*    <label htmlFor="ClientCode">
                    Client Code<sup>*</sup>
                  </label>
                  <input
                    name="ClientCode"
                    value={newCategory.ClientCode}
                    onChange={handleNewCategoryChange}
                    type="text"
                    required
                  />

                  <label htmlFor="EmployeeCode">
                    Employee Code<sup>*</sup>
                  </label>
                  <input
                    name="EmployeeCode"
                    value={newCategory.EmployeeCode}
                    onChange={handleNewCategoryChange}
                    type="text"
                  required 
                  />*/}
                      </div>
                    </Box>
                  </div>
                  {!loading ? (
                    <div
                      style={{ marginTop: "20px" }}
                      className={style["btn-container"]}
                    >
                      <button className={style.buttons} type="submit">
                        <Icon icon="ic:baseline-check" width="24" height="24" />{" "}
                        Submit
                      </button>
                      <button
                        className={style.buttons}
                        style={{
                          backgroundColor: "#fff",
                          color: "#0077d4",
                          border: "1px solid #0077d4",
                        }}
                        type="button"
                        onClick={handleResetField}
                      >
                        <Icon
                          style={{ color: "#0077d4" }}
                          icon="ix:reset"
                          width="24"
                          height="24"
                        />
                        Reset
                      </button>
                      <button
                        className={style.buttons}
                        type="button"
                        onClick={handleList}
                      >
                        <Icon
                          icon="fluent:list-rtl-16-filled"
                          width="24"
                          height="24"
                        />
                        List
                      </button>
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
